<app-si-dialog modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]" header="Export to SalesLoft">
	<ng-template appDialogBody>
		<ng-container *ngIf="accuracyTier">
			<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
		</ng-container>

		<div class="flex flex-col overflow-hidden">
			<ng-container *ngIf="isBusy">
				<div class="flex flex-wrap -mx-2 pl-2 pr-2">
					<div class="w-full md:flex-none md:w-1/12 px-2">
					</div>
					<div class="w-full md:flex-none md:w-5/6 text-center px-2">
						<br /><b>{{busyLabel}}</b><br /><br />
						{{busySublabel}}
					</div>
					<div class="w-full md:flex-none md:w-1/12 px-2">
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.setCadence && !isBusy">
				<h4 class="mb-0 text-primary">Cadence (optional)</h4>
				<div class="italic py-1"> Leave this field blank to export without a cadence</div>

				<div class="flex items-center mb-4">
					<span class="mr-4">Choose Mapping Style</span>
					<mat-radio-group [(ngModel)]="individualFlow">
						<mat-radio-button class="mr-4" name="flow" [value]="false" (click)="toggleFlow($event,false)">Basic Assignment</mat-radio-button>
						<mat-radio-button name="flow" [value]="true" (click)="toggleFlow($event,true)">Advance Assignment</mat-radio-button>
					</mat-radio-group>
				</div>
				<ng-container *ngIf="individualFlow === false">
					<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
						<mat-label>Filter by name</mat-label>
						<input matInput type="text" placeholder="Filter by name" [(ngModel)]="cadenceFilter">
						<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
					</mat-form-field>
					<div class="table-scroll">
						<table class="table-fixed border si-table si-table--striped si-table--hover">
							<thead>
							<tr>
								<th class="flex-none w-11/12 px-2">
									Name
								</th>
								<th class="flex-none w-1/12 px-2">
									&nbsp;
								</th>
							</tr>
							</thead>
							<tbody>
							<tr (click)="selectCadence(cadence.id)"
								*ngFor="let cadence of cadences | filter : cadenceFilter | orderBy : 'name'">
								<td class="flex-none w-11/12 px-2">{{ cadence.name }}</td>
								<td class="flex-none w-1/12 px-2"><fa-icon *ngIf="rowSelected(cadence.id)" class="p-0" [icon]="['fas', 'check']"></fa-icon>
								</td>
							</tr>
							<tr *ngIf="(cadences | filter: cadenceFilter).length === 0">
								<td colspan="2" class="w-full sm:flex-none sm:w-full text-center bg-white py-6 px-2"><i>No
									Cadences Found</i></td>
							</tr>
							</tbody>
						</table>
					</div>
				</ng-container>
				<ng-container *ngIf="individualFlow === true">
					<app-individual-assignment
						class="flex flex-col overflow-hidden"
						[selectedContacts]="contacts"
						[optionsList]="cadences"
						[type]="exportType"
						(exportIds)='onIndividual($event)'
					></app-individual-assignment>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.setTags && !isBusy">
				<h3 class="text-center">Set the Tags</h3>
				<app-chips-selector-form-field-ui
						label="Tags"
						placeholder="Tags"
						bindLabel="name"
						bindValue="name"
						[isLoading]="peopleLoading"
						[items]="selected_tags | async"
						[(ngModel)]="available_tags"
						(searchChanged)="salesLoftInput$.next($event)"
				></app-chips-selector-form-field-ui>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.duplicates && !isBusy">
				<h3 class="pl-1">Duplicates</h3>
				<div class="pl-1 flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-1/2 px-2">
						<b>Found {{duplicateCount}} duplicate<span *ngIf="duplicateCount != 1">s</span>:</b>
					</div>
					<div class="w-full md:flex-none md:w-1/2 px-2">
						<b>Resolve Duplicates by:</b>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-1/2 pl-4 pb-2 table-scroll">
						<table class="table-fixed border si-table si-table--hover">
							<tbody>
							<tr *ngFor="let match of duplicateMatchIds">
								<td class="flex-none w-full px-2">{{match.contact_name}}</td>
							</tr>
							</tbody>
						</table>
					</div>
					<div class="flex-none w-1/2 px-2">
						<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
					</div>
				</div>
			</ng-container>

			<div *ngIf="currentPage == pages.exportEmpty && isBusy == false" class="blank-export">
				<div class="text-center blank-export-center">
					<h3>Nothing to Export</h3>
					All selected contacts are duplicates and you decided to skip duplicates, so there's nothing left to export.
				</div>
			</div>

			<ng-container *ngIf="currentPage == pages.exportFinished && isBusy == false">
				<div class="export-succes table-scroll">
					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-1/12 px-2">
						</div>
						<div class="w-full md:flex-none md:w-5/6 text-center px-2">
							<h3>Export Succeeded</h3>
							You have successfully exported {{exportedContactCount}} contact<span
								*ngIf="exportedContactCount != 1">s</span> to SalesLoft.
							<br /><br />
							<div *ngIf="warnings.length > 0" class="rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm" role="alert">All contacts were
								exported, but for some of the contacts we ran into validation issues.<br /><br /><button
										matButton="filled"
										type="button"
										class="mat-small-button mat-error"
										(click)="showWarnings()"
								>view details</button></div>

							<br />
							<pre class="text-left export-warning" *ngIf="isShowingWarnings">{{warnings | json}}</pre>
							<br />
						</div>
						<div class="w-full md:flex-none md:w-1/12 px-2">
						</div>
					</div>
				</div>
			</ng-container>
			<div *ngIf="currentPage == pages.exportFailed && isBusy == false" class="export-failed">
				<div ng-if="exportError != 'Invalid Bearer token'" class="export-invalid-token">
					<h3>Export Failed</h3>
					Your export failed with the following error: <br /><br />
					<pre class="pre-wrap-error">{{exportError}}</pre><br />
					Please resolve the problem in your SalesLoft instance and retry or contact SalesIntel support at <a
						href="mailto:support@salesintel.io">support&#64;salesintel.io</a>.
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button matButton="outlined" type="button" *ngIf="showCancelButton" (click)="onClose()">Cancel</button>
		</div>
		<div>
			<a matButton="outlined" type="button" (click)="retryExport()" *ngIf="showRetryButton">Retry</a>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="!isBusy && showPreviousButton "
					(click)="previous()">Previous</button>
			<button matButton="filled" type="button" *ngIf="!isBusy && showNextButton" (click)="next()">Next</button>
			<button matButton="outlined" *ngIf="showCloseButton && !isBusy" (click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
